import AllInboxIcon from '@mui/icons-material/AllInbox';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import EditNoteIcon from '@mui/icons-material/EditNote';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import { Box, useTheme } from '@mui/material';
import { Typography } from '@mui/material';
import { useIntl } from 'react-intl';

import { useAnnotatorQueueHeader } from './useAnnotatorQueueHeader';
import { HeaderStatsItem } from '../../workspace-common/components/HeaderStatItem';

const HeaderStatsSection = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const {
    totalTasksCount,
    pendingTasksCount,
    finalizedTasksCount,
    draftTasksCount,
    completedTasksCount,
    isAssignmentCountLoading,
  } = useAnnotatorQueueHeader();
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(6) }}>
      <HeaderStatsItem
        label={formatMessage({ id: 'annotatorQueue.header.stats.total.title' })}
        value={totalTasksCount}
        isLoading={isAssignmentCountLoading}
        icon={<AllInboxIcon sx={{ width: 16, height: 16 }} />}
      />
      <HeaderStatsItem
        label={formatMessage({ id: 'annotatorQueue.header.stats.pending.title' })}
        value={pendingTasksCount}
        isLoading={isAssignmentCountLoading}
        icon={<PendingActionsIcon sx={{ width: 16, height: 16 }} />}
      />
      <HeaderStatsItem
        label={formatMessage({ id: 'annotatorQueue.header.stats.draft.title' })}
        value={draftTasksCount}
        isLoading={isAssignmentCountLoading}
        icon={<EditNoteIcon sx={{ width: 16, height: 16 }} />}
      />
      <HeaderStatsItem
        label={formatMessage({ id: 'annotatorQueue.header.stats.finalized.title' })}
        value={finalizedTasksCount}
        isLoading={isAssignmentCountLoading}
        icon={<CheckCircleOutlineIcon sx={{ width: 16, height: 16 }} />}
      />
      <HeaderStatsItem
        label={formatMessage({ id: 'annotatorQueue.header.stats.completed.title' })}
        value={completedTasksCount}
        isLoading={isAssignmentCountLoading}
        icon={<DoneAllIcon sx={{ width: 16, height: 16 }} />}
      />
    </Box>
  );
};

export const AnnotatorQueueHeader = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  return (
    <Box
      sx={{
        pt: theme.spacing(4),
        pb: theme.spacing(6),
      }}
    >
      <Box>
        <Typography variant="h4">{formatMessage({ id: 'annotatorQueue.header.title' })}</Typography>
      </Box>

      {/* Header stats section */}
      <HeaderStatsSection />
    </Box>
  );
};
